import { HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { Inject, inject } from "@angular/core";
import { SettingsService } from "../services/settings.service";
import { StorageService } from "../services/storage.service";

export function httpAuthInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {

    const auth = inject(SettingsService).getApiAuthentication();
    const sessionId = inject(StorageService).getSessionId();
    let host = getHost();
    // Clone the request to add the authentication header.
    let newReq = req.clone({
        headers: req.headers.set('X-API-KEY', auth.apiKey)
        .set('X-Tenant-ID', auth.tenantId)
        .set('X-Session-ID', sessionId) 
        .set('X-Frontend-Host', host)
        .set('X-Software', auth.software.toString())
    });

    return next(newReq);
}

function getHost() {
    return document.location.href;
}